// TODO: move into exchange domain after exchange refactoring

import { useSearch } from "@tanstack/react-location";
import { useMemo } from "react";

import { TLocationGenerics } from "../pages/routes";
import { ExchangeMode } from "../stores";

export const useOrderMode = () => {
  const search = useSearch<TLocationGenerics>();
  const orderMode = useMemo(() => search.mode ?? ExchangeMode.swap, [search.mode]);
  const isCreateOrder = useMemo(() => orderMode === ExchangeMode.create, [orderMode]);
  const isBuyOrder = useMemo(() => orderMode === ExchangeMode.buy, [orderMode]);
  const isSellOrder = useMemo(() => orderMode === ExchangeMode.sell, [orderMode]);
  const isSwap = useMemo(() => orderMode === ExchangeMode.swap, [orderMode]);

  return {
    orderMode,
    isCreateOrder,
    isBuyOrder,
    isSellOrder,
    isSwap,
  };
};
